import NextImage, { ImageProps as NextImageProps } from 'next/image';

interface ImageProps extends NextImageProps {
  className?: string;
}

const Image = ({ src, alt, className, ...props }: ImageProps) => {
  return (
    <NextImage
      src={src}
      alt={alt || ''}
      className={className}
      {...props}
      unoptimized
    />
  );
};

export default Image;
